module.exports = __webpack_public_path__ + "static/media/pit1.62547783.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pioricost-fruit/pitahaya/pit1.jpeg
// module id = 42
// module chunks = 0